exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{background-color:#fdfffd;box-shadow:5px 5px 5px #888;height:300px;min-width:150px;width:100%;overflow:hidden;border:1px solid}.achievementscontainer{height:300px;width:100%;overflow:auto}.flex1{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-line-pack:start;align-content:flex-start}.achievement{height:200px;width:150px;margin:5px;border-radius:5px;overflow:hidden;float:left;text-align:center;box-shadow:5px 5px 5px #888;background-color:#dedece;opacity:.5}.achievementimage{height:150px;width:150px}.completed{opacity:1}.achievementinfo{background-color:#a9a9a9;width:75px;height:40px;position:absolute;text-align:center;display:none}.achivementinfo p{line-height:0}.buttoncontainer{padding-right:10px;width:100%;height:40px;float:left}.listgroup{float:left;width:100%;margin-bottom:50px}.listbutton{margin-right:10px;margin-top:5px;float:right}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/achievements/achievements.component.css
// module id = 457
// module chunks = 1